import { render, staticRenderFns } from "./AutorExperiencia.vue?vue&type=template&id=7023e956&scoped=true"
import script from "./AutorExperiencia.vue?vue&type=script&lang=js"
export * from "./AutorExperiencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7023e956",
  null
  
)

export default component.exports